
export default function PartnershipOptions() {
  const partnershipTiers = [
    {
      name: 'Strategic Partner',
      investment: '$250,000 - $500,000',
      ownership: '5% - 10%',
      description: 'Perfect for established investors seeking diversified portfolio growth',
      features: [
        'Equity ownership in OED Glamping Developments',
        'Quarterly profit distributions',
        'Access to exclusive investment opportunities',
        'Strategic advisory board participation',
        'Priority booking at all OED properties',
        'Annual partner retreat invitations'
      ],
      returns: '12-18% Annual ROI',
      color: 'emerald'
    },
    {
      name: 'Executive Partner',
      investment: '$500,000 - $1,000,000',
      ownership: '10% - 20%',
      description: 'Ideal for business leaders wanting active involvement',
      features: [
        'Significant equity stake in company growth',
        'Monthly profit distributions',
        'Executive decision-making authority',
        'Direct involvement in site selection',
        'Personal glamping property allocation',
        'Marketing co-branding opportunities',
        'Access to proprietary market research'
      ],
      returns: '18-25% Annual ROI',
      color: 'blue',
      popular: true
    },
    {
      name: 'Founding Partner',
      investment: '$1,000,000+',
      ownership: '20%+',
      description: 'For visionary investors shaping the future of glamping',
      features: [
        'Major equity ownership and voting rights',
        'Weekly profit distributions',
        'C-level executive involvement',
        'Personal property development rights',
        'Exclusive territory expansion opportunities',
        'Brand licensing and franchise rights',
        'International expansion participation',
        'Legacy wealth building program'
      ],
      returns: '25-35% Annual ROI',
      color: 'purple'
    }
  ];

  return (
    <section id="partnership-options" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Partnership Investment Tiers</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the partnership level that aligns with your investment goals and desired involvement in OED's growth
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {partnershipTiers.map((tier, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg p-8 ${
                tier.popular ? 'ring-2 ring-blue-500 transform scale-105' : ''
              }`}
            >
              {tier.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{tier.name}</h3>
                <div className={`text-3xl font-bold text-${tier.color}-600 mb-2`}>{tier.investment}</div>
                <div className={`text-lg font-semibold text-${tier.color}-500 mb-3`}>{tier.ownership} Ownership</div>
                <p className="text-gray-600">{tier.description}</p>
              </div>

              <div className={`bg-${tier.color}-50 rounded-lg p-4 mb-6`}>
                <div className="text-center">
                  <span className="text-sm text-gray-600">Expected Returns</span>
                  <div className={`text-2xl font-bold text-${tier.color}-600`}>{tier.returns}</div>
                </div>
              </div>

              <ul className="space-y-3 mb-8">
                {tier.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <i className={`ri-check-line text-${tier.color}-500 mr-3 mt-1 flex-shrink-0`}></i>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#partnership-application"
                className={`w-full bg-${tier.color}-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-${tier.color}-700 transition-colors text-center block whitespace-nowrap`}
              >
                Apply for {tier.name}
              </a>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            All partnerships include comprehensive legal documentation, due diligence support, and ongoing partnership management
          </p>
        </div>
      </div>
    </section>
  );
}
